import { render, staticRenderFns } from "./EditCragAscentBtn.vue?vue&type=template&id=4218ddd8"
import script from "./EditCragAscentBtn.vue?vue&type=script&lang=js"
export * from "./EditCragAscentBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports